export default __webpack_public_path__ + "static/media/too-tired.47eaa061.png";